import React from "react";
import dayjs from "dayjs";

const GlobalContext = React.createContext({
  monthIndex: 0,
  setMonthIndex: (index) => {},
  smallCalendarMonth: 0,
  setSmallCalendarMonth: (index) => {},
  daySelected: null,
  setDaySelected: (day) => {},
  showEventModal: false,
  setShowEventModal: () => {},
  dispatchCalEvent: ({ type, payload }) => {},
  savedEvents: [],
  selectedEvent: null,
  setSelectedEvent: () => {},
  setLabels: () => {},
  labels: [],
  updateLabel: () => {},
  filteredEvents: [],
  tipoFiltro: 0,
  setTipoFiltro: (index) => {},
  dtInicial: dayjs(), 
  setDtInicial: () => {},
  dtFinal: dayjs().endOf("month"), 
  setDtFinal: () => {},
});

export default GlobalContext;

// 0 = mes atual 
// 1 = prox 7 dias 
// 2 = prox 14 dias 
// 3 = prox 30 dias 
// 4 = personalizado 